import { ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable } from '@app/advisor-frontend';
import { valueID_Yes, valueID_YesNo, valueType_Enumerated, valueType_Range, valueType_StandardRange, valueType_SubEnumerated, valueType_Tuple } from '@app/hcs-shared';
import { filterInstances, MissingDataException, StaticLogger } from '@nu-art/ts-common';
const enumeratedValTypes = [valueType_Enumerated, valueType_Tuple, valueType_SubEnumerated];
const numericValTypes = [valueType_Range, valueType_StandardRange];
export const generateOrderRawFinding = (dbOrder) => {
    let rawFinding;
    const variable = ModuleFE_Advisor_Variable.cache.unique(dbOrder.variableId);
    const value = ModuleFE_Advisor_Value.cache.unique(variable?.valueId);
    if (!variable || !value)
        throw new MissingDataException('Could not derive variable and value from dbOrder');
    if (enumeratedValTypes.includes(value.type)) {
        rawFinding = {
            variableId: variable._id,
            type: 'enumerated',
            isChiefComplaint: false,
            valueIds: [value._id === valueID_YesNo ? valueID_Yes : undefined]
        };
    }
    else if (numericValTypes.includes(value.type))
        rawFinding = {
            variableId: variable._id,
            type: 'numeric',
            isChiefComplaint: false,
            measurementUnitId: value.data.unitsId
        };
    else
        return;
    //Generate children
    if (dbOrder.relatedVariables?.length) {
        rawFinding.children = filterInstances(dbOrder.relatedVariables.map(relatedVarId => {
            const variable = ModuleFE_Advisor_Variable.cache.unique(relatedVarId);
            const value = ModuleFE_Advisor_Value.cache.unique(variable?.valueId);
            if (!variable || !value)
                return;
            if (enumeratedValTypes.includes(value.type))
                return { variableId: variable._id, type: 'enumerated', isChiefComplaint: false, };
            else if (numericValTypes.includes(value.type))
                return {
                    variableId: variable._id,
                    type: 'numeric',
                    isChiefComplaint: false,
                    measurementUnitId: value.data.unitsId
                };
            else {
                StaticLogger.logWarning('OrderFindingsGenerator', `Related Variable with unresolvable type: ${variable.name}`, variable, value);
            }
        }));
    }
    return rawFinding;
};
//# sourceMappingURL=utils.js.map